import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'semantic-ui-react';
import i18next from 'i18next';

import '../DataGrid.scss';

class SelectionFilter extends Component {

    render() {
        const { filter, filterValues, onChange, ...rest } = this.props;

        return (
            <select
                onChange={event => onChange({ exact: true, content: event.target.value })}
                placeholder={i18next.t('choose')}
                value={filter ? filter.value.content : ''}
                className='pi-data-grid-filter-component pi-data-grid-filter-select'
            >
                <option value={''}>{i18next.t("all")}</option>
                {filterValues.map(filterOption => (
                    <option key={filterOption.value} value={filterOption.value}>
                        {filterOption.text}
                    </option>
                ))}
            </select>
        );

    }
}

SelectionFilter.propTypes = {
    filter: PropTypes.object,
    filterValues: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
};

export default SelectionFilter;